import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ValueEncoder } from "../Utils/ValueEncoder";
import { Reason } from "../Export/AssetPandaExport";

export class HuduExport implements ObjectSerializer {
	public static readonly pdfName: string = 'PDF';
	public static readonly svgName: string = 'SVG';
	public static readonly vdxName: string = 'Visio (vdx)';
	public static readonly vsdxName: string = 'Visio (vsdx)';
	public static mapFormatDropdownOptions: string[] = [this.vdxName, this.vsdxName, this.pdfName, this.svgName];

	public EnableExport: boolean;

	public TargetServerApiURL: string;
	public TargetServerApiKey: string;
	public CompanyName: string;
	public NetworkName: string;

	public ExportOrigin: string;

	public ExportDevices: boolean;
	public ExportIpAddresses: boolean;
	public ExportConfigs: boolean;
	public ExportPasswords: boolean;

	public ExportMapToNetwork: boolean;
	public MapFilename: string;
	public MapFileExtension: string;

	public get HasTargetServerApiURL(): boolean {
		return !!this.TargetServerApiURL;
	}

	public get HasTargetServerApiKey(): boolean {
		return !!this.TargetServerApiKey;
	}

	public get HasCompanyName(): boolean {
		return !!this.CompanyName;
	}

	public get HasNetworkName(): boolean {
		return !!this.NetworkName;
	}

	public get HasExportOrigin(): boolean {
		return !!this.ExportOrigin;
	}

	public get HasMapFilename(): boolean {
		return !!this.MapFilename;
	}

	public get HasMapFileExtension(): boolean {
		return !!this.MapFileExtension;
	}

	constructor() {
		this.Clear();
	}

	public Copy(other: HuduExport): void {
		this.Clear();

		this.EnableExport = other.EnableExport;

		this.TargetServerApiURL = other.TargetServerApiURL;
		this.TargetServerApiKey = other.TargetServerApiKey;
		this.CompanyName = other.CompanyName;
		this.NetworkName = other.NetworkName;

		this.ExportOrigin = other.ExportOrigin;

		this.ExportDevices = other.ExportDevices;
		this.ExportIpAddresses = other.ExportIpAddresses;
		this.ExportConfigs = other.ExportConfigs;
		this.ExportPasswords = other.ExportPasswords;

		this.ExportMapToNetwork = other.ExportMapToNetwork;
		this.MapFilename = other.MapFilename;
		this.MapFileExtension = other.MapFileExtension;
	}

	public Clear(): void {
		this.EnableExport = false;

		this.TargetServerApiURL = "";
		this.TargetServerApiKey = "";
		this.CompanyName = "";
		this.NetworkName = "";

		this.ExportOrigin = "agent";

		this.ExportDevices = false;
		this.ExportIpAddresses = false;
		this.ExportConfigs = false;
		this.ExportPasswords = false;

		this.ExportMapToNetwork = false;
		this.MapFilename = "";
		this.MapFileExtension = "";
	}

	public Equals(obj: any): boolean {
		if (!obj)
			return false;

		if (!(obj instanceof HuduExport))
			return false;
		var other = (obj as HuduExport);

		return (
			this.EnableExport == other.EnableExport &&

			this.TargetServerApiURL == other.TargetServerApiURL &&
			this.TargetServerApiKey == other.TargetServerApiKey &&
			this.CompanyName == other.CompanyName &&
			this.NetworkName == other.NetworkName &&

			this.ExportOrigin == other.ExportOrigin &&

			this.ExportDevices == other.ExportDevices &&
			this.ExportIpAddresses == other.ExportIpAddresses &&
			this.ExportConfigs == other.ExportConfigs &&
			this.ExportPasswords == other.ExportPasswords &&

			this.ExportMapToNetwork == other.ExportMapToNetwork &&
			this.MapFilename == other.MapFilename &&
			this.MapFileExtension == other.MapFileExtension);
	}

	public IsValid(reason: Reason): boolean {
		reason.Value = "";

		if (this.EnableExport) {
			if (!this.HasTargetServerApiURL) {
				reason.Value = "The Hudu Server/API URL must be specified";
				return false;
			}
			if (!this.HasTargetServerApiKey) {
				reason.Value = "The Hudu API key must be specified";
				return false;
			}
			if (!this.HasCompanyName) {
				reason.Value = "A Hudu company name must be specified";
				return false;
			}

			return true;
		}
		else {
			return true;
		}
	}

	public Write(obj: any, context: any): void {
		obj.hudu_export = {};
		obj = obj.hudu_export;

		obj.enable_export = ValueEncoder.EncodeBoolean(this.EnableExport);

		if (this.HasTargetServerApiURL)
			obj.target_server_api_url = this.TargetServerApiURL;
		if (this.HasTargetServerApiKey)
			obj.target_server_api_key = this.TargetServerApiKey;
		if (this.HasCompanyName)
			obj.company_name = this.CompanyName;
		if (this.HasNetworkName)
			obj.network_name = this.NetworkName;

		if (this.HasExportOrigin)
			obj.export_origin = this.ExportOrigin;

		obj.export_devices = ValueEncoder.EncodeBoolean(this.ExportDevices);
		obj.export_ip_addresses = ValueEncoder.EncodeBoolean(this.ExportIpAddresses);
		obj.export_configs = ValueEncoder.EncodeBoolean(this.ExportConfigs);
		obj.export_passwords = ValueEncoder.EncodeBoolean(this.ExportPasswords);

		obj.export_map_to_network = ValueEncoder.EncodeBoolean(this.ExportMapToNetwork);
		if (this.HasMapFilename)
			obj.map_file_name = this.MapFilename;
		if (this.HasMapFileExtension)
			obj.map_file_ext = this.MapFileExtension;
	}

	public Read(obj: any, context: any): void {
		this.Clear();

		if (!obj.hudu_export)
			throw new Error();
		obj = obj.hudu_export;

		if (obj.enable_export !== undefined)
			this.EnableExport = ValueEncoder.DecodeBoolean(obj.enable_export);

		if (obj.target_server_api_url !== undefined)
			this.TargetServerApiURL = obj.target_server_api_url;
		if (obj.target_server_api_key !== undefined)
			this.TargetServerApiKey = obj.target_server_api_key;
		if (obj.company_name !== undefined)
			this.CompanyName = obj.company_name;
		if (obj.network_name !== undefined)
			this.NetworkName = obj.network_name;

		if (obj.export_origin !== undefined)
			this.ExportOrigin = obj.export_origin;

		if (obj.export_devices !== undefined)
			this.ExportDevices = ValueEncoder.DecodeBoolean(obj.export_devices);
		if (obj.export_ip_addresses !== undefined)
			this.ExportIpAddresses = ValueEncoder.DecodeBoolean(obj.export_ip_addresses);
		if (obj.export_configs !== undefined)
			this.ExportConfigs = ValueEncoder.DecodeBoolean(obj.export_configs);
		if (obj.export_passwords !== undefined)
			this.ExportPasswords = ValueEncoder.DecodeBoolean(obj.export_passwords);

		if (obj.export_map_to_network !== undefined)
			this.ExportMapToNetwork = ValueEncoder.DecodeBoolean(obj.export_map_to_network);
		if (obj.map_file_name !== undefined)
			this.MapFilename = obj.map_file_name;
		if (obj.map_file_ext !== undefined)
			this.MapFileExtension = obj.map_file_ext;
	}

}